import React, { useEffect, useState } from 'react';

const mins = [
    {id: '/00', name : '00'},
    {id: '/15', name : '15'},
    {id: '/30', name : '30'},
    {id: '/45', name : '45'},
]

export default function TimePickerComponent({ name, icon, options, selectedHour, selectedMin, className, onChange }) {
    const [active, setActive] = useState(false);
    const [hour, setHour] = useState(null);
    const [min, setMin] = useState(selectedMin ? selectedMin : '/00');
    useEffect(() => {
        if(options) {
            if(selectedHour) setHour(selectedHour);
            else setHour(options[0].id);
            setActive(true);
        } else {
            setHour(null);
            setActive(false);
        }
    }, [])
    const handleMinChange = (e) => {
        e.preventDefault();
        setMin(e.target.value);
        onChange(`${hour}${e.target.value}`);
    }
    const handleChange = (e) => {
        e.preventDefault();
        setHour(+e.target.value)
        onChange(`${e.target.value}${min}`);
    }
    return (
        <div className={`item-select py-1 ${className}`}>
            <div className='icon'>
                {icon}
            </div>
            {
                options && options.length !== 0 &&
                <>
                    <select name={`mins_${name}`} id={`mins_${name}`}  onChange={handleMinChange} defaultValue={selectedMin} className='border-bottom' disabled={!active}>
                        {
                            mins.map((item, index) => {
                                return(
                                    <option  key={`option-${index}`} value={item.id}>
                                        {item.name}
                                    </option>
                                )
                            })
                        }
                    </select>
                    <strong className='mx-2 text-secondary'>{":"}</strong>
                    <select name={name} id={name} onChange={handleChange} defaultValue={selectedHour} className='border-bottom ' disabled={!active}>
                        {
                            options.map((item, index) => {
                                return(
                                    <option  key={`option-${index}`} value={item.id}>
                                        {item.name.replace(':00','')}
                                    </option>
                                )
                            })
                        }
                    </select>
                </>
            }
        </div>
    );
};